function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M512 97c-19 9-39 14-60 17 21-13 38-34 46-58-21 12-43 20-67 25a105 105 0 0 0-179 96c-87-4-164-46-216-110a106 106 0 0 0 32 140c-17 0-34-5-48-13v2c0 51 37 93 85 103a105 105 0 0 1-48 1c14 42 52 73 98 74A211 211 0 0 1 0 417c46 30 102 47 161 47a297 297 0 0 0 298-312c21-15 39-34 53-55z"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTUxMiA5N2MtMTkgOS0zOSAxNC02MCAxNyAyMS0xMyAzOC0zNCA0Ni01OC0yMSAxMi00MyAyMC02NyAyNWExMDUgMTA1IDAgMCAwLTE3OSA5NmMtODctNC0xNjQtNDYtMjE2LTExMGExMDYgMTA2IDAgMCAwIDMyIDE0MGMtMTcgMC0zNC01LTQ4LTEzdjJjMCA1MSAzNyA5MyA4NSAxMDNhMTA1IDEwNSAwIDAgMS00OCAxYzE0IDQyIDUyIDczIDk4IDc0QTIxMSAyMTEgMCAwIDEgMCA0MTdjNDYgMzAgMTAyIDQ3IDE2MSA0N2EyOTcgMjk3IDAgMCAwIDI5OC0zMTJjMjEtMTUgMzktMzQgNTMtNTV6Ii8+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };